/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const TrainNetwork = {
  path: '/train-network',
  name: 'train-network',
  redirect: { name: 'train-network-list' },
  component: () => import('@/views/train-network/index.vue'),
  children: [
    {
      path: 'list',
      name: 'train-network-list',
      component: () =>
        import(/* webpackChunkName: "train-network" */ '@/views/train-network/list.vue'),
    },
    {
      path: 'detail',
      name: 'train-network-detail',
      component: () =>
        import(/* webpackChunkName: "train-network" */ '@/views/train-network/detail.vue'),
    },
  ],
}
export default TrainNetwork
